import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { IconAlertTriangle } from '@tabler/icons-react';
import '../css/cartRemoveModal.css';

const { Title, Text } = Typography;

const CartRemoveConfirmModal = ({ visible, onCancel, onConfirm, itemName, loading }) => {
    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            centered
            closable={false}
            width={400}
            className="cart-remove-modal"
            wrapClassName="cart-remove-modal-wrap"
            transitionName="ant-zoom"
            maskTransitionName="ant-fade"
        >
            <div className="remove-modal-content">
                <div className="warning-icon-wrapper">
                    <IconAlertTriangle size={32} stroke={2.5} />
                </div>

                <Title level={4} className="remove-modal-title">
                    Remove this item from your cart?
                </Title>



                <div className="remove-modal-actions">
                    <Button
                        className="remove-modal-btn remove-modal-btn-cancel"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        danger
                        className="remove-modal-btn remove-modal-btn-delete"
                        onClick={onConfirm}
                        loading={loading}
                    >
                        Remove
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CartRemoveConfirmModal;
